// src/contexts/ToastContext.jsx

import React, { createContext, useContext, useCallback, useState } from 'react';
import ToastContainer from '../components/ToastContainer/index.js';

const ToastContext = createContext({
  showToast: (message, type, duration) => {}
});

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'success', duration = 4000) => {
    const id = Date.now(); // ou use qualquer id único
    setToasts((current) => [...current, { id, message, type, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((current) => current.filter(t => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}